import { createApp } from 'vue'
import FormInputEmailField from './FormInputEmailField'

const el = '.kb-component--form-input-email-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputEmailFieldDOM) => {
            const props = {
                tooltipText: FormInputEmailFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputEmailFieldDOM.dataset.errormessagelabel,
                helpMessageLabel:
                    FormInputEmailFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputEmailFieldDOM.dataset.placeholder,
                label: FormInputEmailFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputEmailFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputEmailFieldDOM.dataset.fieldname
            }

            const component = createApp(FormInputEmailField, props).use(Store)
            component.mount(FormInputEmailFieldDOM)
        })
    }
}
